import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles(() =>
  createStyles({
    formHelperTextError: {
      whiteSpace: 'pre-line',
    },
  })
);
